export const BENCHMARKS = {
  conversion: {
    ultraPerformance: 15,
    excellence: 10,
    target: 5,
    min: 2,
    description: "Taxa de conversão média do setor: 2-10%, com meta ideal de 5%"
  },
  roi: {
    ultraPerformance: 500,
    excellence: 400,
    target: 300,
    min: 200,
    description: "ROI médio do setor: 200-500%, com meta ideal de 300%"
  },
  cacTicketRatio: {
    ultraPerformance: 8,
    excellence: 6,
    target: 5,
    min: 3,
    description: "Relação ideal entre Ticket Médio e CAC: mínimo 3x, meta 5x, excelência 8x. Indica quantas vezes o ticket médio é maior que o custo de aquisição."
  },
  costPerLead: {
    ultraPerformance: 50,
    excellence: 50,
    target: 200,
    min: 500,
    description: "Custo por lead médio do setor: R$50-500, meta ideal R$200"
  }
};